import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/strava': {
    width: 369,
    height: 512,
    paths: [
      {
        d: 'M301.6 292L257.7 380.2 213.1 292H145.5L257.7 512 369.2 292H301.6zM151.4 0L0 292H89.2L151.4 175.9 213.1 292H301.6L151.4 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/strava.js
// module id = OAtM
// module chunks = 144